import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Api from "../../services/Api";
import { translate } from "react-admin";
import BatteryChargingFull from "@material-ui/icons/BatteryChargingFull";
import LinearProgress from "@material-ui/core/LinearProgress";
import CardHeader from "@material-ui/core/CardHeader";
import { withStyles } from "@material-ui/core/styles";

class CouponsLeftCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      linearProgressValue: 0,
      totalExpiredItems: 0,
      totalItems: 0
    };
    this.updateCampaignStats();
  }


  updateCampaignStats() {
    const { record } = this.props;

    // Get totalItems
    Api.getCoupons({ campaign: record.id }).then((response) => {
      this.setState({ totalItems: response["hydra:totalItems"] });

      // Get totalExpiredItems
      Api.getCoupons({ campaign: record.id, expired: true }).then((response) => {

        this.setState({
          totalExpiredItems: response["hydra:totalItems"],
          linearProgressValue: Math.floor(response["hydra:totalItems"] / this.state.totalItems * 100)
        });
      });
    });
  }

  render() {
    const { classes, translate } = this.props;

    return (<CardHeader
      className={classes.card}
      avatar={<BatteryChargingFull color="primary" className={classes.icon}/>}
      title={translate("resources.coupons.left", {
        totalExpiredItems: this.state.totalExpiredItems,
        totalItems: this.state.totalItems
      })}
      subheader={<LinearProgress color="secondary" classes={{
        root: classes.progressBar
      }} variant="determinate" value={this.state.linearProgressValue}/>}
    />);
  }
}

CouponsLeftCard.propTypes = {
  replace: PropTypes.func,
  push: PropTypes.func,
  record: PropTypes.object,
  showNotification: PropTypes.func
};
const styles = theme => ({
  card: {
    marginLeft: 0,
    paddingLeft: 0
  },
  icon: {
    margin: theme.spacing.unit * 2,
    fontSize: 60,
    marginLeft: 0,
    paddingLeft: 0
  },
  progressBar: {
    height: 10
  }
});

export default connect(null, {})(withStyles(styles)(translate(CouponsLeftCard)));
